import { mapTwoWayState } from 'schepotin-vuex-helpers';

export default {
    computed: {
        ...mapTwoWayState({
            namespace: 'device',
            prefix: true,
        }, [
            'scanned',
            'connected',
            'terminalData',
            'tab',
            'isEnableBtTab',
            'isEnableUsbTab',
            'isEnableUpdateOs',
        ]),
    },
};



// WEBPACK FOOTER //
// ./src/mixins/device.js